export enum Languages {
  EN = 'en',
  RU = 'ru',
  DE = 'de',
  SW = 'sw'
}
